import React, {Component} from 'react';
import {LIVE} from "../../config";
import {FaCalendarAlt, FaBookOpen, FaUser, FaPlay, FaYoutube, FaBook, FaArrowRight, FaHeart} from 'react-icons/fa';
import {GiChurch} from 'react-icons/gi';

class Live extends Component {
    componentDidMount() {
        document.title = "EECF|基督教法国华人教会|Live"
    }

    render() {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100">
                {/* Hero Section */}
                <section className="relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-100/30 to-blue-200/30"></div>
                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 md:py-16 lg:py-10">
                        <div className="text-center">
                            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                                在线主日崇拜
                            </h1>
                            <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
                                与我们一起敬拜神，聆听祂的话语，在信仰中共同成长
                            </p>
                            <div className="flex items-center justify-center space-x-2 mt-6">
                                <FaHeart className="text-red-500 animate-pulse" />
                                <span className="text-gray-600 font-medium">愿神的话语照亮你的心</span>
                                <FaHeart className="text-red-500 animate-pulse" />
                            </div>
                        </div>
                    </div>
                </section>

                {/* Live Content */}
                <section className="py-5">
                    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                        {/* Live Card */}
                        <div className="card overflow-hidden">
                            {/* Card Header */}
                            <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-8 relative overflow-hidden">
                                <div className="absolute inset-0 bg-black/10"></div>
                                <div className="relative text-center">
                                    <div className="flex items-center justify-center mb-4">
                                        <div className="flex items-center space-x-2 bg-white/20 px-4 py-2 rounded-full backdrop-blur-sm mx-auto">
                                            <div className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></div>
                                            <span className="text-white text-sm font-medium">最新直播</span>
                                        </div>
                                    </div>
                                    <h2 className="text-3xl font-bold text-white leading-tight">{LIVE.theme}</h2>
                                </div>
                            </div>

                            {/* Card Body */}
                            <div className="p-8">
                                {/* Info Grid */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                                    <div className="flex items-center space-x-4 p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border border-blue-200">
                                        <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
                                            <FaCalendarAlt className="w-6 h-6 text-white" />
                                        </div>
                                        <div>
                                            <p className="text-sm font-semibold text-blue-700">日期</p>
                                            <p className="font-semibold text-gray-900">{LIVE.date}</p>
                                        </div>
                                    </div>

                                    <div className="flex items-center space-x-4 p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border border-blue-200">
                                        <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
                                            <FaBookOpen className="w-6 h-6 text-white" />
                                        </div>
                                        <div>
                                            <p className="text-sm font-semibold text-blue-700">经文</p>
                                            <p className="font-semibold text-gray-900">{LIVE.chapter}</p>
                                        </div>
                                    </div>

                                    <div className="flex items-center space-x-4 p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border border-blue-200">
                                        <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
                                            <FaUser className="w-6 h-6 text-white" />
                                        </div>
                                        <div>
                                            <p className="text-sm font-semibold text-blue-700">讲员</p>
                                            <p className="font-semibold text-gray-900">{LIVE.speaker}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Video Player */}
                                <div className="mb-10">
                                    <div className="relative w-full pb-[56.25%] rounded-2xl overflow-hidden shadow-2xl">
                                        <iframe
                                            src={`https://www.youtube.com/embed/${LIVE.youtubeVideoCode}?rel=0&modestbranding=1`}
                                            title="EECF主日崇拜"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            className="absolute inset-0 w-full h-full"
                                        ></iframe>
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <a 
                                        href={`https://www.youtube.com/watch?v=${LIVE.youtubeVideoCode}`}
                                        className="flex-1 inline-flex items-center justify-center space-x-3 px-8 py-4 bg-gradient-to-r from-blue-600 to-red-700 text-white font-semibold rounded-xl hover:from-red-700 hover:to-red-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaPlay className="w-5 h-5" />
                                        <span>在YouTube观看直播</span>
                                    </a>
                                    
                                    <a 
                                        href="https://youtube.com/@eecf"
                                        className="flex-1 inline-flex items-center justify-center space-x-3 px-8 py-4 bg-gradient-to-r from-red-700 to-red-700 text-white font-semibold rounded-xl hover:from-red-900 hover:to-red-900 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaYoutube className="w-5 h-5" />
                                        <span>浏览YouTube频道</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Encouragement Section */}
                <section className="py-5 bg-white">
                    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 border border-blue-200">
                            <FaHeart className="w-8 h-8 text-red-500 mx-auto mb-4" />
                            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                                愿神的话语成为你脚前的灯
                            </h3>
                            <p className="text-gray-700 leading-relaxed">
                                无论你身在何处，神的话语都能照亮你的道路。愿每一次的敬拜都能让你的心灵得到更新，在基督的爱中不断成长。
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Live;